import { render } from "./AdministratorOrderDetailsComponent.vue?vue&type=template&id=8d2e3d6c"
import script from "./AdministratorOrderDetailsComponent.vue?vue&type=script&lang=js"
export * from "./AdministratorOrderDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/administrators/AdministratorOrderDetailsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d2e3d6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d2e3d6c', __exports__)) {
    api.reload('8d2e3d6c', __exports__)
  }
  
  module.hot.accept("./AdministratorOrderDetailsComponent.vue?vue&type=template&id=8d2e3d6c", () => {
    api.rerender('8d2e3d6c', render)
  })

}


export default __exports__